exports.CONTAINER_CLASS = "codeblock-container";
exports.BUTTON_CLASS = "codeblock-copy-button";
